import React from 'react'

import { CALENDAR_EVENTS_LIMIT, useCalendarEvents } from './_load/CalendarLoader'
import Message from '../../../components/messenger/Message'

const LimitWarning = () => {
  const events = useCalendarEvents()
  if (events?.length !== CALENDAR_EVENTS_LIMIT) return false

  return (
    <Message
      icon="RiErrorWarningLine"
      title={`Apresentando somente os primeiros ${CALENDAR_EVENTS_LIMIT} eventos`}
      message="Utilize os filtros para ter uma visão mais precisa"
      bgColor="lightYellow"
      iconSize={1.4}
    />
  )
}

export default LimitWarning
